import ServiceShiftUI from "serviceshift-ui";
import { mask } from "vue-the-mask";
import { createApp } from "vue";
import SlideOut from 'vue3-slider';
import { getProperty, isFalsy } from "@/lib/helpers.js";
import * as mixins from "@/mixins";
import * as membershipMixins from "@/mixins/membership.js";
import * as pathHelperMixins from "@/mixins/path_helpers.js";
import store from "@/vuex/store";
import router from "@/router";
import VueSafeTeleport from 'vue-safe-teleport';

export const AppMixins = {
  ...mixins,
  ...membershipMixins,
  ...pathHelperMixins,
  getProperty,
  isFalsy
};

export const bootstrapApp = (render, props = {}) => {
  const App = createApp({
    store,
    render,
  }, props);
  App.use(router);
  App.use(store);
  App.use(ServiceShiftUI);
  App.use(SlideOut);
  App.use(VueSafeTeleport);
  App.directive("mask", mask);
  App.mixin({
    methods: AppMixins
  });
  return App;
}
